<template>
    <div id="form">
        <preloader v-show="loading"></preloader>

        <sme-form-message
            v-if="isError"
            title="Не смогли отправить вашу заявку"
            subtitle="По техническим причинам мы не смогли отправить вашу заявку. Повторите попытку позже"
            type="error"
        />

        <sme-form-message
            v-if="sended && !isError"
            title="Ваша заявка успешно отправлена"
            subtitle="Наш оператор свяжется с вами в ближайшее время и проконсультирует по вопросам"
            type="sent"
        />

        <div v-if="!sended && !isError" class="reform__bg" :style="{ backgroundImage: !!bgImage ? `url(${bgImage})` : undefined }">
            <div class="_inner-padding">

                <div class="sme-reform__container">
                    <div class="h2 _mb-20" v-html="title"></div>
                    <!-- Заявка на {{ this.product }}-->
                    <div class="reform__group"  :class="{'_rko' : currentUrl === '/sme/rko/rates/' || '/sme/overdraft/'}">
                        <DInput
                            v-model.trim="$v.phone.$model"
                            label="Телефон"
                            id="phone_number"
                            name="phone"
                            placeholder="+7"
                            inputmode="tel"
                            :error="$v.phone.$error && isTrySubmit"
                            type="tel"
                            v-mask="'+7 ### ###-##-##'"
                        >
                            <template #messages v-if="$v.phone.$error && isTrySubmit">
                                <p v-if="!$v.phone.required && isTrySubmit">Это поле необходимо заполнить.</p>
                                <p v-if="!$v.phone.minLength && isTrySubmit">Пожалуйста, введите не&nbsp;меньше 11&nbsp;символов.</p>
                            </template>
                        </DInput>
                        <div class="form__item">
                            <vue-suggestion
                                :class="{ '_invalid': $v.company.$error, '_focus': company.length, '_open': isSuggestionOpen }"
                                name="company_name"
                                v-model="company"
                                label="Название организации или ИНН"
                                method="party"
                                @blur="checkEmptyCompany"
                                @selectNothing="nameOrInnSuggestionOptions.onSelectNothing"
                                @select="nameOrInnSuggestionOptions.onSelect($event)"
                            >
                            </vue-suggestion>
                            <p class="form-error" v-if="$v.company.$error && !$v.company.required">Это поле необходимо заполнить.</p>
                        </div>
                    </div>

                    <div v-if="!hideAgreement" class="reform__group _mt-32">
                        <DCheckbox
                            v-model="$v.agreement.$model"
                            :error="$v.agreement.$error && isTrySubmit"
                        >
                            <p class="p2">Я&nbsp;соглашаюсь с&nbsp;
                                <a target="_blank" href="/upload/docs/sme/soglasie_na_obrabotku_personalnyh_dannyh.pdf">
                                    условиями использования персональных данных</a><br>и подтверждаю согласие на использование
                                <a href="/upload/docs/sme/soglashenie_ob_ispolzovanii_pep.pdf" target="_blank">
                                    простой электронной подписи</a></p>
                            <template #messages v-if="$v.agreement.$error && isTrySubmit">
                                <p>Обязательное поле</p>
                            </template>
                        </DCheckbox>
                    </div>

                    <div class="form__group">
                        <DButton @click="submitForm" class="_w-available-m _justify-content-center" v-html="button"></DButton>
                    </div>

                    <div v-if="!noSecurity" class="form__item">
                        <div class="sme-reform__notice text-gray">
                            Мы&nbsp;защищаем ваши персональные данные, не&nbsp;раскрываем их&nbsp;третьим лицам и&nbsp;не&nbsp;распространяем без вашего согласия на&nbsp;это, если иное не&nbsp;предусмотрено законодательством
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <modal-with-yandex-captcha
            :requested="modalSmsShow"
            :phone="phone"
            endpoint="callbackSmeForm"
            @closeCaptchaSms="modalSmsShow = false"
            @smsConfirmed="callMe"
        />

        <simple-yandex-captcha
            v-if="captchaShow"
            @action="callMe"
        />

        <d-modal
            v-cloak
            name="agreement_pep"
            popup-title="Соглашение об использовании простой электронной подписи"
            size="wide"
        >
            <p class="d-modal__text p1">
                <slot name="agreement_pep"></slot>
            </p>
            <br>
        </d-modal>
    </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength } from 'vuelidate/lib/validators'
import axios from 'axios'
import SmeFormMessage from './SmeFormMessage.vue';
import { DButton } from '@ahml/domrfbank-ui/elements/DButton';
import { DCheckbox } from '@ahml/domrfbank-ui/elements/DCheckbox';
import { DInput } from '@ahml/domrfbank-ui/elements/DInput';

export default {
    name: 'SmeLk',
    mixins: [
        validationMixin,
    ],
    components: {
        SmeFormMessage,
        DButton,
        DCheckbox,
        DInput,
    },
    props: {
        product: {
            type: String,
            required: true
        },
        title: {
            type: String,
            default: ''
        },
        privacyPolicy: {
            type: String,
            default: '/upload/medialibrary/638/Aprovement.pdf'
        },
        noSecurity: {
            type: Boolean,
            required: false
        },
        button: {
            type: String,
            default: 'Заполнить онлайн'
        },
        bgImage: {
            type: String,
            default: '/local/templates/redesign/src/assets/img/sme/rko/rates/form.webp',
        },
    },
    data() {
        return {
            loading: false,
            company: '',
            inn: '',
            phone: '',
            isSuggestionOpen: false,
            agreement: false,
            sended: false,
            isIpOooOpf: false,
            sessid: window.config.bitrix_sessid,
            currentUrl: '',
            modalSmsShow: false,
            captchaShow: false,
            hideAgreement: false,
            isError: false,
            companyDadata: null,
            nameOrInnSuggestionOptions: {
                serviceUrl: window.config.dadata_url,
                type: 'PARTY',
                scrollOnFocus: false,
                noSuggestionsHint:{
                    PARTY: 'Введите корректные <br> наименование организации или ИНН'
                },
                deferRequestBy: 300,
                beforeRender: () => {
                    this.isSuggestionOpen = true;
                },
                onSelectNothing: () => {
                    this.companyDadata = null;
                    this.company = '';
                    this.isSuggestionOpen = false;
                },
                onSelect: (suggestion) => {
                    this.companyDadata = suggestion;
                    this.company = suggestion.value;
                    this.inn = suggestion.data.inn;
                    if (suggestion.data.opf.code === '50102' || suggestion.data.opf.code === '12300') {
                        this.isIpOooOpf = true;
                    } else {
                        this.isIpOooOpf = false;
                    }
                }
            },
            isTrySubmit: false,
        }
    },
    validations: {
        company: {
            required,
        },
        phone: {
            required,
            minLength: minLength(16),
        },
        agreement: {
            required: val => val
        },
    },
    computed: {
        productCode() {
            let code;

            switch(this.product) {
                case 'Экспресс-кредит': code = 'ExpressCreditProduct'; break;
                case 'Экспресс-Овердрафт': code = 'ExpressOverdraft'; break;
                case 'открытие расчетного счета': code = 'RKO'; break;
            }

            return code
        }
    },
    created() {
        this.currentUrl = window.location.pathname;
    },
    methods: {
        checkEmptyCompany() {
            this.$nextTick(() => {
                if (!this.companyDadata) {
                    this.company = '';
                }
            })
        },
        getProductCode(product) {
            let code;

            switch(product) {
                case 'Экспресс-кредит': code = 'ExpressCreditProduct'; break;
                case 'Экспресс-Овердрафт': code = 'ExpressOverdraft'; break;
                case 'открытие расчетного счета': code = 'RKO'; break;
            }

            return code
        },
        getProductCodeYM(product) {
            let code;

            switch(product) {
                case 'Экспресс-кредит': code = 'expr-credit'; break;
                case 'Экспресс-Овердрафт': code = 'overdraft'; break;
            }

            return code
        },
        getProductType(product) { // для запроса в бэк
            let type;

            switch(product) {
                case 'Экспресс-кредит': type = 'Экспресс-кредит'; break;
                case 'Экспресс-Овердрафт': type = 'Экспресс-Овердрафт'; break;
                case 'открытие расчетного счета': type = 'РКО'; break;
            }

            return type
        },
        smeRedirect() {
            window.dmpkitdl.push({event: 'sme-lead-fos-send'});
            if (this.productCode !== 'RKO') {
                setTimeout(() => { window.location = 'https://business.domrfbank.ru/?phone=' + this.phone.replace(/\D/g, '') + '&productType=open-loan&productSubType=' + this.getProductCode(this.product) + '&inn=' + this.inn }, 1000);
            } else {
                setTimeout(() => { window.location = 'https://business.domrfbank.ru/?phone=' + this.phone.replace(/\D/g, '') + '&product=' + this.product + '&inn=' + this.inn }, 1000);
            }
        },
        submitForm() {
            this.isTrySubmit = true;
            if (this.isIpOooOpf) {
                this.$v.company.$touch();
                this.$v.phone.$touch();
                if (!this.$v.company.$invalid && !this.$v.phone.$invalid ) {
                    return this.captchaShow = true;
                }
            }
            this.$v.$touch();

            if (!this.$v.company.$invalid && !this.$v.phone.$invalid && !this.$v.agreement.$invalid) {
                this.modalSmsShow = true;
            }
        },
        callMe() {
            this.$v.$touch();
            if (this.isIpOooOpf) return this.smeRedirect();

            if (!this.$v.$invalid) {
                this.loading = true;

                let data = {
                    data: {
                        type: "callbackSmeForm",
                        attributes: {
                            productName: this.getProductType(this.product),
                            inn: this.inn,
                            companyName: this.company,
                            phone: this.phone.replace(/\D/g, ''),
                            agreement: true
                        }
                    }
                }

                axios.post('/rest/v1/callbackSme?sessid=' + this.sessid, data)
                    .then(() => {
                        this.sended = true;
                        window.dmpkitdl.push({event: 'sme-lead-fos-send'});
                    })
                    .catch(err => {
                        if (err.response.status === 422) {
                            this.isError = true;
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    })
            }
        }
    },
    watch: {
        isIpOooOpf(val) {
            this.isIpOooOpf = val;
            this.isIpOooOpf ? this.hideAgreement = true : this.hideAgreement = false;
        },
        company() {
            this.companyDadata = null;
        }
    },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/base/_variables.scss';
@import '../../assets/scss/base/_mixins.scss';
@import '../../assets/scss/base/_functions.scss';

.reform  {
    &__bg {
        @include fluid('padding-top', 56px, 24px);
        @include fluid('padding-bottom', 56px, 24px);
        @include fluid('border-radius', 56px, 24px);
        background-color: $grey-106;
        background-repeat: no-repeat;
        background-size: 50% auto;
        background-position: 100% 100%;

        @include mobile {
            background-image: none !important;
            @include fluid('padding-right', $ind2);
            @include fluid('padding-left', $ind2);
        }
    }

    &__group {

        .form__item {

            &:not(:first-child) {
                @include fluid('margin-top', 32px);
            }
        }
    }
}

.sme-reform {

    &__container {
        @include fluid('width', 592px, $mobile-block-case);

        &-broad {
            @include fluid('width', $base-form-inner, $mobile-block-case);
            margin: 0 auto;
        }
    }

    &__notice {
        position: relative;
        @include fluid('font-size', 12px);
        @include fluid('line-height', 16px);
        @include fluid('padding-left', 32px);
        @include fluid('padding-top', 12px);

        &::before {
            content: '';
            position: absolute;
            @include fluid('top', 12px);
            left: 0;
            @include fluid('height', 24px);
            @include fluid('width', 24px);
            background-image: url("/local/templates/redesign/src/assets/img/ico/safety_grey.svg");
            background-repeat: no-repeat;
            background-size: contain;
        }
    }
}

</style>
